// import { useEffect } from 'react';
// import { useLocation, useNavigationType } from 'react-router-dom';

// export default function ScrollToTop() {
//   const { pathname } = useLocation();
//   const navigationType = useNavigationType(); // POP / PUSH / REPLACE

//   useEffect(() => {
//     // Always scroll to top on PUSH navigation (clicks, links, programmatic)
//     // Optionally also on POP (back/forward), if desired
//     if (navigationType === "PUSH" || navigationType === "POP") {
//       window.scrollTo({
//         top: 0,
//         left: 0,
//         behavior: "smooth"
//       });
//     }
//   }, [pathname, navigationType]);

//   return null;
// }

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, [pathname]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      const scrollTop =  0;
      window.scrollTo({
        top: scrollTop,
        // behavior: "smooth",
      });
    }, 100); // Small delay ensures DOM is rendered

    return () => clearTimeout(timeout);
  }, [pathname]);

  return null;
}
